// extracted by mini-css-extract-plugin
module.exports = {"tabContent":"Employee_tabContent__a6l_9","employeeTable":"Employee_employeeTable__3NSGD","operations":"Employee_operations__5lhmq"};